import { Injectable } from '@angular/core';
import { DqGateRepository } from '../repositories/dq-gate.repository';
import { IDQGateQuarantineModel } from '../entities-api/IDQGateQuarantineModel';
import { IDQGateDetailModel } from '../entities-api/IDQGateDetailModel';
import { IDQGateAuditLogModel } from '../entities-api/IDQGateAuditLogModel';
import { IDQGateSnapshotModel } from '../entities-api/IDQGateSnapshotModel';
import { IDQGateRejectResult } from '../entities-api/IDQGateRejectResult';

@Injectable()
export class DqGateService {

    constructor(private repository: DqGateRepository) { }

    getPending(): Promise<IDQGateQuarantineModel[]> {
        return this.repository.getPending();
    }

    getStatus(quarantineId: string): Promise<IDQGateQuarantineModel> {
        return this.repository.getStatus(quarantineId);
    }

    getDetail(quarantineId: string): Promise<IDQGateDetailModel[]> {
        return this.repository.getDetail(quarantineId);
    }

    getSnapshot(quarantineId: string): Promise<IDQGateSnapshotModel[]> {
        return this.repository.getSnapshot(quarantineId);
    }

    getAuditLog(runId: string): Promise<IDQGateAuditLogModel[]> {
        return this.repository.getAuditLog(runId);
    }

    approve(quarantineId: string, snapshotIds: string[]): Promise<any> {
        return this.repository.approve(quarantineId, snapshotIds);
    }

    reject(quarantineId: string, snapshotIds: string[], comments?: string): Promise<IDQGateRejectResult> {
        return this.repository.reject(quarantineId, snapshotIds, comments);
    }

    retry(quarantineId: string): Promise<void> {
        return this.repository.retry(quarantineId);
    }
}
